var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id)?_c('span',{staticClass:"authorization-id"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('AuthorizationId.label'))}}),_vm._v(" "+_vm._s(_vm.id)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }